var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListaClientesPotenciales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 178.21 109.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffa726;}.cls-2{fill:#455a64;}.cls-3{fill:#ffb74d;}.cls-4{fill:#607d8b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lista-clientes-potenciales") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 40.5,
    cy: 40.5,
    r: 20.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,96S11.34,70.48,40.5,70.48,81,96,81,96v13.37H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.21,96s-11.34-25.51-40.5-25.51S97.21,96,97.21,96v13.37h81Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 89.11,
    cy: 24.3,
    r: 24.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.71,93.56s-13.37-30.38-48.6-30.38S40.5,93.56,40.5,93.56v15.8h97.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 137.71,
    cy: 40.5,
    r: 20.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 40.5,
    cy: 40.5,
    r: 20.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 137.71,
    cy: 40.5,
    r: 20.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListaClientesPotenciales);
export default __webpack_public_path__ + "static/media/lista-clientes-potenciales.f6857255204a0eab2dfd631c0b8bb894.svg";
export { ForwardRef as ReactComponent };